<!--
 * @Author: wufei
 * @Date: 2020-08-13 15:58:09
 * @LastEditTime: 2020-08-18 16:35:12
 * @Description:
 * @FilePath: \mobile-revive\src\views\report\reviveReport\index.vue
-->
<template>
  <div class="report-index">
    <basic v-if="active === 'basic'" :land-id="landId" :active="active" :replay-form="replayForm" @switchMenu="switchMenu" />
    <first v-if="active === 'first'" :land-id="landId" :active="active" :replay-form="replayForm" @switchMenu="switchMenu" />
    <month v-if="active === 'month'" :land-id="landId" :active="active" @switchMenu="switchMenu" />
  </div>
</template>

<script>
import basic from './basic'
import first from './first'
import month from './month'
import { getNewReplayFrom } from '@/api/revive'
export default {
    name: 'ReportIndex',
    components: {
        basic,
        first,
        month
    },
    data() {
        return {
            landId: this.$route.query['landId'],
            active: 'basic',
            replayForm: {},
            isObtains: 0
        }
    },
    watch: {
        isObtains(newVal) {
            console.log(newVal)
            this.isObtains = newVal
        }
    },
    created() {
        // this.fetchReplayFrom()

    },
    methods: {
        switchMenu(type) {
            this.active = type
        }
    }
}
</script>

<style lang="scss" scoped>
  .report-index {

  }
</style>
